export default {
  Montserrat: "'Montserrat', sans-serif",
};
